import React from 'react';

import TogglePillGroup from 'components/consumer/TogglePillGroup';

const TypeRefinementList = ({ items, refine }) => {
  const selectedItems = (items || [])
    .filter(item => item.isRefined)
    .map(item => item.value);

  return (
    <TogglePillGroup
      items={items?.map(item => ({
        id: item.value,
        label: item.label,
        count: item.count,
        onClick: () => {
          refine(item.value);
        },
      }))}
      selectedItems={selectedItems}
      groupName="Type"
      bindValues
    />
  );
};

export default TypeRefinementList;
